import {InformationsStatut} from './information-statut';

/**
 * Représente le statut d'une réservation de trajet.
 */
export enum StatutReservationTrajetEnum {
	// VALIDEE : La réservation est validée
	VALIDEE = 'VALIDEE',
	// ANNULEE : La réservation est annulée
	ANNULEE = 'ANNULEE'
}

export const StatutsReservationTrajet: Map<StatutReservationTrajetEnum, InformationsStatut> = new Map<StatutReservationTrajetEnum, InformationsStatut>([
	[StatutReservationTrajetEnum.VALIDEE, { cleTraduction: 'RESERVATION_NAVETTE.RESERVATION.STATUTS.VALIDEE', couleur: 'green' }],
	[StatutReservationTrajetEnum.ANNULEE, { cleTraduction: 'RESERVATION_NAVETTE.RESERVATION.STATUTS.ANNULEE', couleur: 'red' }],
]);